import * as styles from  'sass/variables/breakpoints.scss';

const breakpoint = {
    sm: {
        width: styles.bpSmMin
    },
    md: {
        width: styles.bpMdMin
    },
    dt: {
        width: styles.bpDtMin
    },
    dtL: {
        width: styles.bpDtLMin
    },
    dtXL: {
        width: styles.bpDtXLMin
    }
}

export default breakpoint;